module.exports = __webpack_public_path__ + "img/logo.18c889bc.png";